export const GOOGLE_MAP_API_KEY = 'AIzaSyCef0RSbTETGD3bssmgqfUh2772Ca1Qd9w'
// process.env.REACT_APP_PROJECT_ID === 'sacri-6bae3'
//   ? 'AIzaSyAf2NQF2oTrVoamWgKvylV9qWdf37WiA-Q'
//   : 'AIzaSyCef0RSbTETGD3bssmgqfUh2772Ca1Qd9w'
